import styled from "styled-components";
import imagen from "../assets/login.jpg" 

export const Contenedorimagen2=styled.div`
    background-size: cover; 
    background-image: url(${imagen});
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: rgba(15, 23, 42, 0.45);
    background-blend-mode: soft-light;
    height: 100%;
    width: 100%;
`